"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const Sprite = ({
  className,
  name
}) => {
  const classes = (0, _classnames.default)('Sprite', `sprite-${name}`, className);
  return /*#__PURE__*/_react.default.createElement("i", {
    className: classes
  });
};
var _default = exports.default = Sprite;